export default __webpack_public_path__ + "static/rics-844ca098980afaeb6b1aa712ea9a5b05.svg";